export default __webpack_public_path__ + "static/media/IMG_2586.28a5c7a2.jpeg";